import { render, staticRenderFns } from "./Mail-configuration.vue?vue&type=template&id=066ad81c"
import script from "./Mail-configuration.vue?vue&type=script&lang=js"
export * from "./Mail-configuration.vue?vue&type=script&lang=js"
import style0 from "./Mail-configuration.vue?vue&type=style&index=0&id=066ad81c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports